// Save media to the device. On mobile (iOS/Android) use the native share sheet
// so the user can save straight to their photo gallery ("Save Image"/"Save Video").
// On desktop fall back to a normal file download.
function dataUrlToBlob(dataUrl) {
  const comma = dataUrl.indexOf(",");
  const meta = dataUrl.slice(0, comma);
  const b64 = dataUrl.slice(comma + 1);
  const mimeMatch = meta.match(/data:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

function anchorDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

const isMobile = () =>
  /iphone|ipad|ipod|android/i.test(navigator.userAgent || "") ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export async function downloadFile(dataUrl, filename) {
  let blob;
  try {
    if (dataUrl && !dataUrl.startsWith("data:")) {
      const r = await fetch(mediaUrl(dataUrl));
      if (!r.ok) throw new Error("fetch failed");
      blob = await r.blob();
    } else {
      blob = dataUrlToBlob(dataUrl);
    }
  } catch (e) {
    try { window.open(mediaUrl(dataUrl), "_blank"); } catch (_) {}
    return;
  }
  // Mobile: open the native share sheet → "Save Image" / "Save to Photos" / "Save Video".
  // dataUrlToBlob is synchronous, so navigator.share is still inside the click gesture.
  try {
    const file = new File([blob], filename, { type: blob.type });
    if (isMobile() && navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file] });
      return;
    }
  } catch (err) {
    if (err && err.name === "AbortError") return; // user dismissed the share sheet
    // any other error → fall through to a normal download
  }
  anchorDownload(blob, filename);
}

export async function saveBlob(blob, filename) {
  try {
    const file = new File([blob], filename, { type: blob.type });
    if (isMobile() && navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file] });
      return;
    }
  } catch (err) {
    if (err && err.name === "AbortError") return;
  }
  anchorDownload(blob, filename);
}
